export enum MenuPages {
  MAIN = 'main_page',
  ORGANIZATIONS = 'organizations',
  ANALITICS = 'analytics',
  STAFFS = 'staff',
  CLIENTS = 'clients',
  SUBPARTNERS = 'subpartners',
  ORGANIZATION_CHECK = 'organization_check',
  CART = 'cart',
  CATALOG = 'catalog',
  COURSES_REQUESTS = 'courses',
  MARKETING = 'marketing',
  SOFTWARE_LICENSES = 'software_licenses',
  DISPATCHES = 'realizations',
  INVOICES = 'invoices',
  PROJECTS = 'projects',
  VIDEOS = 'videos',
  NEWS = 'news',
  STAFF_CERTS = 'staff_certs',
  CERTIFICATES_STAFF = 'certificates_staff',
  REPORT_ORDERS = 'report_orders',
  REPORT_SERVICE_RESULT = 'report_service_result',
  REPORT_PERIOD_REPAIRS = 'report_period_repairs',
  CERTIFICATION = 'certification',
  MARKETING_FUND = 'marketing_fund',
  REPORTS = 'reports',
  CART_HISTORY = 'cart-history',
  SUBPARTNERS_SALES = 'subpartner_sales',
  RETURNED_ZIP = 'returned_zip',
  WARRANTY = 'warranty',
  BRAND_PORTAL = 'brand_portal',
  PATCHNOTES = 'patch_notes',
  MARKETING_FUND_EVENT = 'marketing_fund_event',
  REPAIRS = 'order_sides',
  REPORT_SALES = 'report_sales',
  LEADS = 'leads',
  REPORT_INVOICES = 'report_invoices',
  SERVICE = 'service',
  ORDERS = 'orders',
  RETRO_BONUSES = 'retro_bonuses',
  COMMERCIAL_PROPOSAL = 'commercial_proposal',
  MARKETING_MATERIALS = 'marketing_materials',
  REQUEST_CONFERENCE = 'request_conference',
  CONTACT_INFORMATION = 'contact_information',
  CALENDAR = 'webinar_calendar',
  PURCHASE_ORDERS = 'purchase_orders',
  DATA_PILOT = 'data_pilot',
  LOANS = 'loans',

  /**
   * Внешние ссылки
   */
  DOWNLOAD_CENTER = 'download_center',
  USER_GUIDE = 'user_guide',
  TELEPHONE = 'telephone',
  E_MAIL = 'e_mail',
  WEBSITE = 'website',
}

export const MenuLinks: Record<string, string> = {
  [MenuPages.MAIN]: '/',
  [MenuPages.ORGANIZATIONS]: '/organizations',
  [MenuPages.ANALITICS]: '/analytics',
  [MenuPages.STAFFS]: '/staffs',
  [MenuPages.CLIENTS]: '/clients',
  [MenuPages.SUBPARTNERS]: '/subpartners',
  [MenuPages.ORGANIZATION_CHECK]: '/organization_check',
  [MenuPages.CART]: '/cart',
  [MenuPages.CATALOG]: '/catalog',
  [MenuPages.COURSES_REQUESTS]: '/courses',
  [MenuPages.MARKETING]: '/marketing',
  [MenuPages.SOFTWARE_LICENSES]: '/software_licenses',
  [MenuPages.DISPATCHES]: '/dispatches',
  [MenuPages.INVOICES]: '/orders/invoices',
  [MenuPages.PROJECTS]: '/projects',
  [MenuPages.VIDEOS]: '/videos',
  [MenuPages.NEWS]: '/news',
  [MenuPages.STAFF_CERTS]: '/certificates',
  [MenuPages.CERTIFICATES_STAFF]: '/certificates',
  [MenuPages.REPORT_ORDERS]: '/report_orders',
  [MenuPages.REPORT_SERVICE_RESULT]: '/report_service_result',
  [MenuPages.REPORT_PERIOD_REPAIRS]: '/report_period_repairs',
  [MenuPages.CERTIFICATION]: '/certification',
  [MenuPages.MARKETING_FUND]: '/marketing_fund',
  [MenuPages.REPORTS]: '/reports',
  [MenuPages.CART_HISTORY]: '/cart-history',
  [MenuPages.SUBPARTNERS_SALES]: '/subpartner_sales',
  [MenuPages.RETURNED_ZIP]: '/repairs/return-zips',
  [MenuPages.WARRANTY]: '/repairs/warranty-check',
  [MenuPages.BRAND_PORTAL]: '/brand_portal',
  [MenuPages.PATCHNOTES]: '/patchnotes',
  [MenuPages.MARKETING_FUND_EVENT]: '/marketing_fund_event',
  [MenuPages.REPAIRS]: '/repairs',
  [MenuPages.REPORT_SALES]: '/report_sales',
  [MenuPages.LEADS]: '/leads',
  [MenuPages.REPORT_INVOICES]: '/report_invoices',
  [MenuPages.SERVICE]: '/service',
  [MenuPages.ORDERS]: '/orders',
  [MenuPages.RETRO_BONUSES]: '/retro_bonuses',
  [MenuPages.COMMERCIAL_PROPOSAL]: '/commercial_offers',
  [MenuPages.MARKETING_MATERIALS]: '/materials',
  [MenuPages.REQUEST_CONFERENCE]: '/conferences',
  [MenuPages.CONTACT_INFORMATION]: '/contacts',
  [MenuPages.CALENDAR]: '/calendar',
  [MenuPages.PURCHASE_ORDERS]: '/purchase-orders',
  [MenuPages.DATA_PILOT]: '/data-pilot',
  [MenuPages.DATA_PILOT]: '/smartradar',
  [MenuPages.LOANS]: '/loans',

  /**
   * Внешние ссылки
   */
  [MenuPages.DOWNLOAD_CENTER]: 'download_center',
  [MenuPages.USER_GUIDE]: 'user_guide',
  [MenuPages.TELEPHONE]: 'telephone',
  [MenuPages.E_MAIL]: 'e_mail',
  [MenuPages.WEBSITE]: 'website',
};
